export default function getNotificationSessionStorageKey(username) {
  return `notification_modal_showed_${username}`;
}
